/** SearchSuggest copy for equipment manufacturing/utilization fields. */
export const EQUIPMENT_SEARCH_SUGGEST_FIELD_PROPS: Record<
    string,
    { placeholder: string; newLabel: string; disabledMessage?: string }
> = {
    manufacturerName: {
        placeholder: 'Search manufacturers...',
        newLabel: '+ Add manufacturer',
        disabledMessage: 'Select a category first',
    },
    modelNumber: {
        placeholder: 'Search models...',
        newLabel: '+ Add model',
        disabledMessage: 'Select a manufacturer first',
    },
    engineManufacturer: {
        placeholder: 'Search engine manufacturers...',
        newLabel: '+ Add engine manufacturer',
    },
    engineModelNumber: {
        placeholder: 'Search engine models...',
        newLabel: '+ Add engine model',
        disabledMessage: 'Select an engine manufacturer first',
    },
};
